import React, { useState, useEffect } from "react";
import { Router, Link, Redirect } from "@reach/router";
import LearnPage from "./LearnPage";

function LearnPageRouter(props) {
  return (
    <Router>
      <LearnPage path="step/:stepId" />

      {/* <LearnPage path="step/1" default/> */}
      <Redirect from="/*" to="/learn/step/1" noThrow />
    </Router>
  );
}
export default LearnPageRouter;
